<mat-form-field class="w-100" appearance="outline">
  <mat-label *ngIf="label">{{label}}</mat-label>
  <input class="select-input" type="text" (focusin)="inputFocus($event)" matInput [formControl]="selectControl" [matAutocomplete]="selectorId">
  <mat-icon class="arw-icon" (click)="loadData($event)">arrow_drop_down</mat-icon>
  <mat-autocomplete  #selectorId="matAutocomplete" [displayWith]="displayFn" (optionSelected)="selected($event)">
    <mat-option *ngIf="isLoading">
      <div fxLayout="row" fxLayoutAlign="center center">
        <mat-spinner diameter="30"></mat-spinner>
      </div>
    </mat-option>
    <mat-option *ngFor="let option of filteredOptions | async" [value]="option"  [disabled]="disableOptions.includes(option)">
      {{option.label || option}}
    </mat-option>
  </mat-autocomplete>
</mat-form-field>
